import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';
import type { Project } from '@/generated/types';

const PROJECT_QUERY = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      address
      startDate
      endDate
      paymentMethod
      hasConstructionTracking
      hasAdhocTracking
      internalNotes
      status
      creator {
        id
        fullName
        email
      }
      members {
        id
        fullName
        email
        role
      }
      pendingInvitations {
        id
        email
        status
        inviterName
        createdAt
        expiresAt
      }
      clients {
        id
        fullName
        email
      }
      projectFileMetadata {
        countsByMediaType {
          mediaType
          count
        }
      }
      hasFinancialAccess
      createdAt
      updatedAt
    }
  }
`;

export type { Project };

export function useProject(id: string) {
  const { data, loading, error, refetch } = useQuery(PROJECT_QUERY, {
    variables: { id },
    skip: !id,
  });

  const project = (data as { project?: Project } | undefined)?.project;

  return { project, loading, error, refetch };
}
